interface ComponentContextMenuProps {
  x: number;
  y: number;
  onLocate: () => void;
  onClose: () => void;
}

export function ComponentContextMenu({ x, y, onLocate, onClose }: ComponentContextMenuProps) {
  return (
    <>
      <button
        type="button"
        aria-label="Close context menu"
        className="fixed inset-0 z-40 cursor-default"
        onClick={onClose}
        onContextMenu={event => {
          event.preventDefault();
          onClose();
        }}
      />
      <div
        className="fixed z-50 overflow-y-auto rounded-md border border-white/10 bg-[#242a31] p-1 text-[12px] text-slate-200 shadow-xl shadow-black/30"
        style={{ left: x, top: y, width: "min(15rem, calc(100vw - 16px))", maxHeight: "calc(100vh - 16px)" }}
        role="menu"
      >
        <button
          type="button"
          className="h-8 w-full rounded px-2 text-left hover:bg-white/[0.08]"
          onClick={onLocate}
          role="menuitem"
        >
          Locate
        </button>
      </div>
    </>
  );
}
